import React from "react";
import IconHome from "../../../../styles/icons/IconHome";

interface ButtonProps {
  text: string;
  icon?: string;
  activeColor?: string;
  cssClass?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}
const Button: React.FC<ButtonProps> = ({
  text,
  icon,
  activeColor,
  cssClass,
  onClick,
}) => {
  return (
    <button className={`btn ${cssClass}`} onClick={onClick}>
      <span className="btn-text">{text}</span>
      {icon && (
        <span className={text ? "btn-icon" : ""}>
          <IconHome
            breadcrumb={icon}
            activeColor={activeColor ? activeColor : ""}
          />
        </span>
      )}
    </button>
  );
};

export default Button;
